import { useState, useRef } from "react";
import { Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router";
import QuoteForm from "../common/QuoteForm/QuoteForm";
import { Quote } from "../types/Quote";

function New({
  project_id,
  account,
  permissions,
  project,
  revenueCalculationLabel,
  labels,
}) {
  const navigate = useNavigate();
  const submitRef = useRef<any>();
  const [quote, setQuote] = useState<Quote>({
    id: "0",
    description: "",
    oneTimeCost: "0.0",
    oneTimeRevenue: "0.0",
    markup: "",
    mrrMarkup: "",
    recurringCost: "0.0",
    recurringRevenue: "0.0",
    billingFrequency: {
      value: "one_time",
      label: "No",
    },
    billingMethod: {
      value: "time_and_materials",
      label: "Time and Materials",
    },
  });

  return (
    <div className="newQuotePage">
      <Card>
        <Card.Body>
          <Card.Header className="cardHeaderOverride">
            <div className="headerContainer">
              <div className="actionBtns">
                <Button
                  style={{ marginRight: "20px" }}
                  className="btnSeawhite"
                  onClick={(e) =>
                    navigate(`/projects/${project_id}/quotes`, {
                      state: null,
                    })
                  }
                >
                  Cancel
                </Button>
                <div>
                  <span className="text24">{`Add ${labels.quote}`}</span>
                </div>
              </div>
              <div className="actionBtns">
                {permissions.quotes !== "view" &&
                project?.data?.attributes?.status === "building" ? (
                  <Button
                    style={{ width: "200px", marginRight: "10px" }}
                    className="btnSeawhite"
                    onClick={() => {
                      submitRef.current?.saveQuote(true);
                    }}
                  >
                    Save and Add Another
                  </Button>
                ) : null}
                {permissions.quotes !== "view" &&
                project?.data?.attributes?.status === "building" ? (
                  <Button
                    className="squareGreenButton"
                    onClick={() => {
                      submitRef.current?.saveQuote(false);
                    }}
                  >
                    Save
                  </Button>
                ) : null}
              </div>
            </div>
          </Card.Header>
          <QuoteForm
            quote={quote}
            setQuote={setQuote}
            setPreviousQuote={() => null}
            project_id={project_id}
            account={account}
            ref={submitRef}
            permissions={permissions}
            project={project}
            revenueCalculationLabel={revenueCalculationLabel}
            label={labels.quote}
          />
        </Card.Body>
      </Card>
    </div>
  );
}

export default New;
